import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import en from './locales/en.json'
import fr from './locales/fr.json'
import sw from './locales/sw.json'
import ig from './locales/ig.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      sw: { translation: sw },
      ig: { translation: ig },
    },
    lng: 'fr',
    fallbackLng: 'fr',
    detection: {
      order: ['localStorage', 'cookie'],
      caches: ['localStorage', 'cookie'],
    },
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
